module.exports = __webpack_public_path__ + "static/media/sketches.132f72b1.png";